import { cloneDeep as _cloneDeep, get as _get } from 'lodash-es';
import { getAttachmentList } from '@/management/api/archivist';
import { getPlanDetail } from '@/management/api/plan';
import { Message } from 'element-ui';

export default {
  async init({ state, dispatch, commit }) {
    const planId = _get(state, 'planId');
    commit('setPlanId', planId);
    const res = await getPlanDetail(planId);
    if (res.code === 200) {
      const planMeta = res.data;
      commit('initPlan', planMeta);
    } else {
      throw new Error(res.msg || '计划不存在');
    }
  },
  async getFileList({ state, dispatch, commit }) {
    state.fileLoading = true;
    commit('updateSearchParams', state.searchParams);
    state.searchParams.planId = state.planId;
    let res = await getAttachmentList(state.searchParams);
    if (res.code == 200) {
      // state.attachmentsTotal = res.data.total;
      commit('setAttachmentList', res.data);
      setTimeout(() => {
        state.fileLoading = false;
      }, 100);
    } else {
      state.fileLoading = false;
      Message.error(res.msg);
      // throw new Error(res.msg);
    }
  },
};
